<template>
    <v-container fluid>
        <div>
            <GeneralInformation :general-info="generalInfo" />
        </div>
        <div v-if="surveyIdComp !== null" class="mt-4">
            <AddSurvey :isDisabled="true" :surveyIdComp="surveyIdComp"></AddSurvey>
        </div>
    </v-container>
</template>

<script>
    import GeneralInformation from '@/components/app/followUp/GeneralInformation.vue'
    import AddSurvey from '@/pages/Admin/Surveys/AddSurvey.vue'
    import ProcessesService from '@/services/ProcessesService.js'

    export default {
        components: {
            GeneralInformation, AddSurvey
        },

        data() {
            return {
                loading: false,
                generalInfo: null,
                surveyIdComp:null,
                processId: parseInt(this.$route.params.processInstanceId)
            }
        },

        created() {
            this.getProcess()
        },

        methods: {
            getProcess() {
                this.loading = true
                ProcessesService.getProcess(this.processId)
                    .then((res) => {
                        this.generalInfo = res.data
                        this.surveyIdComp = Number(this.generalInfo.processTitle.split('إجراء الموافقة على الاستبيانات بعنوان ')[1])
                       
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
    }
</script>

<style>
</style>